import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';
import { Toggle } from './Toggle';

interface DrawerAdvancedSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const DrawerAdvancedSection: React.FC<DrawerAdvancedSectionProps> = ({ config, setConfig }) => (
  <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-emerald-500/5 border-emerald-500/20 mb-4">
    <SectionLabel icon="fa-paint-brush" darkMode={config.darkMode}>Drawer Advanced</SectionLabel>
    <SmartInput label="Line Thickness" min={1} max={10} value={config.drawerLineThickness} onChange={v => setConfig(p => ({...p, drawerLineThickness: v}))} darkMode={config.darkMode} />
    <SmartInput label="Line Opacity" min={0} max={1} step={0.01} value={config.drawerLineOpacity} onChange={v => setConfig(p => ({...p, drawerLineOpacity: v}))} darkMode={config.darkMode} />
    <SmartInput label="Min Radius" min={1} max={100} value={config.drawerMinRadius} onChange={v => setConfig(p => ({...p, drawerMinRadius: v}))} darkMode={config.darkMode} />
    <div className="flex items-center justify-between border border-white/5 p-2 rounded-xl">
        <span className="text-[10px] font-black uppercase opacity-60">Reverse Mode</span>
        <Toggle active={config.drawerReverseMode} onClick={() => setConfig(p => ({...p, drawerReverseMode: !p.drawerReverseMode}))} color="bg-emerald-600" />
    </div>
    <SmartInput label="Growth Rate" min={0} max={0.2} step={0.001} value={config.growthRate} onChange={v => setConfig(p => ({...p, growthRate: v}))} darkMode={config.darkMode} />
  </div>
);